import { actService } from '@/_services'
export const act = {
  namespaced: true,
  state: {
    myAct: null,
    loadingAct: false,
    signedActs: null,
    availableYears: null,
    notViewedMyAct: null,
  },
  getters: {
  },

  mutations: {
    setMyAct(state, act){
      state.myAct = act
      if(act.signedActs) state.signedActs = act.signedActs
      else state.signedActs = null
    },

    setLoading(state, loadingState) {
      state.loadingAct = loadingState
    },
    
    setSignedActs(state, act) {
      state.signedActs = act.signedActs
    },

    setAvailableYears(state, availableYears) {
      state.availableYears = availableYears
    },

    setNotViewedMyAct(state, act) {
      state.notViewedMyAct = act
    },

    setCheckActStatus(state, status) {
      state.myAct.viewed = status
      let index = state.notViewedMyAct.findIndex((item) => item.id == state.myAct.id)
      if (index !== -1) {
        state.notViewedMyAct.splice(index, 1)
      }
    },

    setNotViewedActFromWebSocket(state, act) {
      if(state.notViewedMyAct) {
        if(!state.notViewedMyAct.some(el => el.id == act.id)){
          state.notViewedMyAct.push(act)
        }
      } else {
        state.notViewedMyAct = [].push(act)
      }
    },

    deleteNotViewedActFromWebSocket(state, act) {
      let index = state.notViewedMyAct.findIndex((item) => item.id == act.id)
      if (index !== -1) {
        state.notViewedMyAct.splice(index, 1)
      }
    }
  },

  actions: {
    loadMyAct({ commit, dispatch }, { month, year }) {
      return actService.loadMyAct(month, year).then(data => {
        commit('setMyAct', data)
        if(data && !data.viewed) {
          dispatch('checkMyAct', data.id)
        }
      })
    },

    saveLoadActs({ commit }, obj) {
      return actService.saveLoadActs(obj).then(data => {
        commit('setSignedActs', data)
      })
    },

    loadAvailableYears({ commit }) {
      return actService.getAvailableYears().then(data => {
        commit("setAvailableYears", data)
      })
    },

    loadNotViewedMyAct({ commit }) {
      return actService.getNotViewedMyAct().then(data => {
        commit("setNotViewedMyAct", data)
      })
    },

    checkMyAct({ commit }, actId) {
      return actService.checkAct(actId).then(() => {
        commit("setCheckActStatus", true)
      })
    }
  },
  
}